import React from 'react';
import { getAppHomePath } from '../../constants/navigation';
import EnterpriseManagementPage from '../EnterpriseManagementPage';
import { useTranslation } from 'react-i18next';

const IdentityEnterprises = () => {
  const { t } = useTranslation(['identity', 'nav', 'common']);
  return (
    <EnterpriseManagementPage
      breadcrumbs={[
        { label: t('common:home'), to: getAppHomePath() },
        { label: t('nav:identities'), to: '/identity/enterprises' },
        { label: t('enterprisesTitle') },
      ]}
    />
  );
};

export default IdentityEnterprises;
